export default __webpack_public_path__ + "static/media/logo2.7faaf849.png";